import { Text } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";
import MarkdownRenderer from "../MarkdownRenderer";

export type ChatMessageRole = "assistant" | "user";

export type ChatMessage = {
	id: string;
	role: ChatMessageRole;
	content: string;
};

type Props = {
	message: ChatMessage;
};

export const MessageContainer = ({ message }: Props) => {
	const theme = useAppTheme();

	const alignment = message.role === "assistant" ? "flex-start" : "flex-end";
	const color =
		message.role === "assistant"
			? theme.colors.onSurfaceVariant
			: theme.colors.onPrimary;
	const bgColor =
		message.role === "assistant"
			? theme.colors.surfaceVariant
			: theme.colors.primary;

	return (
		<Box flexDirection="row" justifyContent={alignment}>
			<Box
				maxWidth="80%"
				backgroundColor={bgColor}
				padding={16}
				borderRadius={theme.roundness}
			>
				<MarkdownRenderer
					text={message.content}
					fontSize={16}
					customStyles={{
						text: {
							lineHeight: 24,
							color,
						},
						code_inline: {
							borderRadius: 4,
							textWrap: "nowrap",
							padding: 4,
						},
					}}
					overrideRules={{
						// biome-ignore lint/suspicious/noExplicitAny: Valid use case
						strong: (node: any, children: any) => (
							<Text key={node.key} variant="titleMedium">
								{children}
							</Text>
						),
					}}
				/>
			</Box>
		</Box>
	);
};
